import React from 'react';
import { BitwerxOfferingsTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { BitwerxOffering } from '@v2/types';

const columns: Column<BitwerxOffering>[] = [
  {
    key: 'name',
    header: 'Offerings',
    sortKey: 'name',
    render: (row) => (
      <div className={styles.nameContainer}>
        <span className={styles.name}>{row.name}</span>
      </div>
    ),
  },
  {
    key: 'subOfferings',
    header: 'Sub-offerings',
    render: (row) => (
      <span className={styles.subCount}>
        {row.subOfferings?.length ?? 0}
      </span>
    ),
  },
];

const BitwerxOfferingsTable: React.FC<BitwerxOfferingsTableProps> = ({
  offerings,
  loading,
  error,
  onSelectOffering,
  selectedOfferingId,
  sortConfig,
  onSortChange,
}) => {
  if (error) {
    return (
      <div className={styles.errorContainer}>
        <p className={styles.error}>{error}</p>
      </div>
    );
  }

  return (
    <Table<BitwerxOffering>
      columns={columns}
      data={offerings}
      keyExtractor={(offering) => offering.id}
      loading={loading}
      emptyMessage="No Bitwerx offerings found."
      onRowClick={onSelectOffering}
      selectedKeys={selectedOfferingId ? [selectedOfferingId] : []}
      maxHeight="calc(100vh - 200px)"
      sortConfig={sortConfig ?? null}
      onSortChange={onSortChange}
    />
  );
};

export default BitwerxOfferingsTable;
